<template>
    <div>
        <form autocomplete="off" class="trax-form mb-4" v-show="!disabled && dafLaunchPermission && atpDafEditStatus">

            <trax-ui-input :placeholder="lang.polaris.procedure.title" col="md-3"
                v-model="form.name" :error="errors.name" required="1">
            </trax-ui-input>

            <trax-ui-select :placeholder="lang.polaris.procedure.urgence" col="md-3"
                v-model="form.priority_level_code" :error="errors.priority_level_code" 
                :options="priority_levels_select">
            </trax-ui-select>

            <trax-ui-select :placeholder="lang.polaris.procedure.learners" col="md-3"
                v-model="form.user_ids" :options="learners_select" :error="errors.user_ids" 
                multiple="1" required="1">
            </trax-ui-select>

            <trax-ui-input :placeholder="lang.polaris.procedure.problem_description" col="md-3"
                rows="7" v-model="form.description" :error="errors.description" required="1">
            </trax-ui-input>

            <trax-ui-select :placeholder="lang.polaris.procedure.reason" col="md-3"
                v-model="form.daf_reason_code" :error="errors.daf_reason_code" 
                :options="daf_reasons_select">
            </trax-ui-select>

            <trax-ui-datetime :placeholder="lang.polaris.procedure.new_end_date" col="md-3"
                v-model="form.new_end_date" :error="errors.new_end_date" type="date">
            </trax-ui-datetime>

            <trax-ui-input :placeholder="lang.polaris.common.hdv_ref" col="md-3"
                v-model="form.hdv_ref" :error="errors.hdv_ref">
            </trax-ui-input>
        </form>

        <div class="pb-3" v-show="disabled || !dafLaunchPermission || !atpDafEditStatus">

            <trax-ui-html :placeholder="lang.polaris.procedure.title" 
                v-model="form.name" col="md-3">
            </trax-ui-html>

            <trax-ui-html :placeholder="lang.polaris.procedure.urgence" 
                v-model="priorityLevel" col="md-3">
            </trax-ui-html>

            <trax-ui-html :placeholder="lang.polaris.procedure.learners" 
                v-model="learnersHtml" col="md-3">
            </trax-ui-html>

            <trax-ui-html :placeholder="lang.polaris.procedure.problem_description" 
                v-model="form.description" col="md-3">
            </trax-ui-html>

            <trax-ui-html :placeholder="lang.polaris.procedure.reason" 
                v-model="dafReason" col="md-3">
            </trax-ui-html>

            <trax-ui-html :placeholder="lang.polaris.procedure.new_end_date"
                v-model="newEndDate" col="md-3">
            </trax-ui-html>

            <trax-ui-html :placeholder="lang.polaris.common.hdv_ref"
                v-model="form.hdv_ref" col="md-3">
            </trax-ui-html>
        </div>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-procedure-atp-daf-edit'},
            source: {default: '1'},
            target: {default: 'final'}
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                registration: data.registration,
                phase: data.phase,
                priority_levels_select: data.priority_levels_select,
                priority_levels_names: data.priority_levels_names,
                daf_reasons_select: data.daf_reasons_select,
                daf_reasons_names: data.daf_reasons_names,
                learners_select: data.learners_select,
                learners_names: data.learners_names,
                form: {
                    name: '',
                    priority_level_code: 'next_meeting',
                    daf_reason_code: '',
                    user_ids: [],
                    description: '',
                    new_end_date: '',
                    hdv_ref: '',
                },
                errors: {},
                disabled: true,
                bus: this.$bus
            }
        },
        
        computed: {

            priorityLevel: function() {
                return this.priority_levels_names[this.form.priority_level_code];
            },

            dafReason: function() {
                return this.daf_reasons_names[this.form.daf_reason_code];
            },

            newEndDate: function() {
                return moment(this.form.new_end_date).format('DD MMM YYYY');
            },

            phaseHdvRef: function() {
                if (!this.phase || !this.phase.custom || !this.phase.custom.meta) return '';
                return this.phase.custom.meta.hdv_ref ? this.phase.custom.meta.hdv_ref : '';
            },

            learnersHtml: function() {
                var html = '<ul class="pl-3">';
                for (var index in this.form.user_ids) {
                    html += '<li>'+this.learners_names[this.form.user_ids[index]]+'</li>';
                }
                html += '</ul>';
                return html;
            },

            dafLaunchPermission: function() {
                if (this.user.admin || this.user.permissions['procedure.write-daf']) return true;
                var userFunction = this.user.user_function;
                if (!userFunction) return false;
                return userFunction == 'training' || userFunction == 'training_op';
            },

            atpDafEditStatus: function() {
                return this.registration.status != 'draft' && this.registration.status != 'archived';
            }
        },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.bus.$on(this.id+'-updated', this.setData);
            this.bus.$on(this.id+'-'+this.source+'-save', this.saveData);
            this.bus.$on(this.id+'-errors', this.setErrors);
        },

        methods: {

            setData(procedure) {
                this.form.name = procedure.name;
                if (procedure.data.daf_launch) {
                    this.form.description = procedure.data.daf_launch.description;
                    if (procedure.data.daf_launch.priority_level_code) {
                        this.form.priority_level_code = procedure.data.daf_launch.priority_level_code;
                    }
                    if (procedure.data.daf_launch.daf_reason_code) {
                        this.form.daf_reason_code = procedure.data.daf_launch.daf_reason_code;
                    }
                    if (procedure.data.daf_launch.new_end_date) {
                        this.form.new_end_date = procedure.data.daf_launch.new_end_date;
                    }
                    if (procedure.data.daf_launch.hdv_ref) {
                        this.form.hdv_ref = procedure.data.daf_launch.hdv_ref;
                    }
                }
                if (procedure.users) {
                    this.form.user_ids = procedure.users.map(user => user.id);
                }
                this.disabled = (procedure.data.daf_launch_submit != undefined);
                if (!this.disabled && !this.form.hdv_ref) {
                    this.form.hdv_ref = this.phaseHdvRef;
                }
            },

            saveData(data) {
                this.errors = {};
                data.name = this.form.name;
                data.user_ids = this.form.user_ids;
                data.data = { daf_launch: { 
                    description: this.form.description,
                    priority_level_code: this.form.priority_level_code,
                    daf_reason_code: this.form.daf_reason_code,
                    new_end_date: this.form.new_end_date,
                    hdv_ref: this.form.hdv_ref,
                }};
                this.bus.$emit(this.id+'-'+this.target+'-save', data);
            },

            setErrors(errors) {
                var my_errors = {};
                for (var index in errors) {
                    var errorNames = index.split('.');
                    var errorName = errorNames[errorNames.length-1];
                    my_errors[errorName] = errors[index];
                }
                this.errors = my_errors;
            }
        }
    }
</script>
